import { GridRowId } from "@mui/x-data-grid-premium";
import { createSlice } from "@reduxjs/toolkit";
import VwOrganizasyonYetkiDTO from "src/models/Base/Yetki/VwOrganizasyonYetkiDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";

export interface IOrganizasyonYetkiState {
    open: boolean,
    organizasyon: VwOrganizasyonYetkiDTO,
    expandedRows: Record<GridRowId, boolean>,
}

const organizasyon: VwOrganizasyonYetkiDTO = sessionStorage.getItem('userOrganizasyon')
    ? JSON.parse(sessionStorage.getItem('userOrganizasyon'))
    : new VwOrganizasyonYetkiDTO();


const OrganizasyonYetkiSlice = createSlice<IOrganizasyonYetkiState, MapReducerPayloads<IOrganizasyonYetkiState, {
    setOpen: boolean,
    setOrganizasyon: VwOrganizasyonYetkiDTO,
    setExpandedRows: Record<GridRowId, boolean>,
}>>({
    name: 'OrganizasyonYetkiSlice',
    initialState: {
        open: false,
        organizasyon: organizasyon,
        expandedRows: {},
    },
    reducers: {
        setOpen: (state, action) => {
            state.open = action.payload
        },
        setOrganizasyon: (state, action) => {
            sessionStorage.setItem("userOrganizasyon", JSON.stringify(action.payload))
            state.organizasyon = action.payload
        },
        setExpandedRows: (state, action) => {
            state.expandedRows = action.payload
        },
    }
})
export default OrganizasyonYetkiSlice;